import { render, staticRenderFns } from "./transferenceManagebar.vue?vue&type=template&id=20494278&"
import script from "./transferenceManagebar.vue?vue&type=script&lang=js&"
export * from "./transferenceManagebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports